import * as actionTypes from './actionTypes';
import { viewModes } from './selectors';

const initialState = {
  selectedData: [],
  activeViewMode: viewModes.classical,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SELECTED_DATA:
      return {
        ...state,
        selectedData: action.selectedData,
      };
    case actionTypes.SET_VIEW_MODE:
      return {
        ...state,
        activeViewMode: action.activeViewMode,
      };
    default:
      return state;
  }
};
